import { render, staticRenderFns } from "./ModuleCarousel.vue?vue&type=template&id=1e812a78&scoped=true&"
import script from "./ModuleCarousel.vue?vue&type=script&lang=js&"
export * from "./ModuleCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ModuleCarousel.vue?vue&type=style&index=0&id=1e812a78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e812a78",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCarousel,VCarouselItem,VSheet})
